import { render, staticRenderFns } from "./JobSubjectLeader.vue?vue&type=template&id=c47737a8&scoped=true"
import script from "./JobSubjectLeader.vue?vue&type=script&lang=js"
export * from "./JobSubjectLeader.vue?vue&type=script&lang=js"
import style0 from "./JobSubjectLeader.vue?vue&type=style&index=0&id=c47737a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47737a8",
  null
  
)

export default component.exports